// extracted by mini-css-extract-plugin
export default {"PlotSteps":"nd9auk1S","overlay":"ho7YZFdq","backButton":"uSafN5D3","buttonLink":"goywsVm8","nextButtons":"RmvFvtaE","type1":"krUvjCKt","preloadImg":"TaGdRdVQ","green50":"omdqVYGR"};
    if(module.hot) {
      // 1721070004823
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  